module.exports = __webpack_public_path__ + "fd3b7dafa3408b18e4010ad014508bc1.svg";